
export default {
  props: {
    video: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      playingInterval: null,
    }
  },
  computed: {
    isYoutubeVideo() {
      return this.video.videoPath.includes('youtube.com')
    },
    isVimeoVideo() {
      return this.video.videoPath.includes('vimeo.com')
    },
  },
  methods: {
    YOUTUBE_SETUP() {
      const vm = this

      // 3. This function creates an <iframe> (and YouTube player)
      //    after the API code downloads.
      var player = null
      function onYouTubeIframeAPIReady() {
        console.log('onYouTubeIframeAPIReady')
        // get video id from embed youtube video url
        let videoId = vm.video.videoPath.split('embed/')[1] || ''
        console.log(videoId, 'video id')
        if (videoId.includes('?')) videoId = videoId.split('?')[0]
        player = new YT.Player('player', {
          width: '100%',
          videoId: videoId,
          playerVars: {
            playsinline: 1,
            // close suggestions
            rel: 0,
            // close related videos
            iv_load_policy: 3,
            // close annotations
            cc_load_policy: 0,
          },
          events: {
            onReady: onPlayerReady,
            onStateChange: onPlayerStateChange,
          },
        })
      }

      // 4. The API will call this function when the video player is ready.
      function onPlayerReady(event) {
        console.log('onPlayerReady')
        vm.$emit('video:init', vm.YOUTUBE_PLAYER_SETUP(player))
        setTimeout(() => {
          player.playVideo()
        }, 1000)
      }

      // 5. The API calls this function when the player's state changes.
      //    The function indicates that when playing a video (state=1),
      //    the player should play for six seconds and then stop.
      function onPlayerStateChange(event) {
        console.log(event.data)
        console.log(YT.PlayerState)
        if (event.data == YT.PlayerState.ENDED) {
          vm.$emit('video:ended', vm.YOUTUBE_PLAYER_SETUP(player))
          clearInterval(vm.playingInterval)
        } else if (event.data == YT.PlayerState.PLAYING) {
          vm.$emit('video:play', vm.YOUTUBE_PLAYER_SETUP(player))
          vm.playingInterval = setInterval(() => {
            console.log('playing')
            vm.$emit('video:playing', vm.YOUTUBE_PLAYER_SETUP(player))
          }, 1000)
        } else if (event.data == YT.PlayerState.PAUSED) {
          vm.$emit('video:pause', vm.YOUTUBE_PLAYER_SETUP(player))
          clearInterval(vm.playingInterval)
        }
      }
      onYouTubeIframeAPIReady()
    },
    YOUTUBE_PLAYER_SETUP(player) {
      return {
        currentTime: (duration = 0) =>
          duration ? player.seekTo(duration) : player.getCurrentTime(),
      }
    },
    VIMEO_SETUP() {
      const vm = this
      const iframe = document.getElementById('iframe')
      const player = new Vimeo.Player(iframe)

      player.ready().then(async () => {
        console.log('ready')
        const currentTime = await player.getCurrentTime()
        vm.$emit('video:init', vm.VIMEO_PLAYER_SETUP(currentTime, player))
      })

      player.on('play', async () => {
        console.log('play')
        const currentTime = await player.getCurrentTime()
        vm.$emit('video:play', vm.VIMEO_PLAYER_SETUP(currentTime))
      })
      player.on('pause', async () => {
        console.log('pause')
        const currentTime = await player.getCurrentTime()
        vm.$emit('video:pause', vm.VIMEO_PLAYER_SETUP(currentTime))
      })
      player.on('ended', async () => {
        console.log('ended')
        const currentTime = await player.getCurrentTime()
        vm.$emit('video:ended', vm.VIMEO_PLAYER_SETUP(currentTime))
      })
      player.on('timeupdate', async () => {
        console.log('timeupdate')
        const currentTime = await player.getCurrentTime()
        vm.$emit('video:playing', vm.VIMEO_PLAYER_SETUP(currentTime))
      })
      player.on('seeked', async () => {
        console.log('seeked')
        const currentTime = await player.getCurrentTime()
        vm.$emit('video:seeked', vm.VIMEO_PLAYER_SETUP(currentTime))
      })
      player.on('ready', async () => {
        console.log('ready')
        const currentTime = await player.getCurrentTime()
        vm.$emit('video:init', vm.VIMEO_PLAYER_SETUP(currentTime))
      })
      player.on('loaded', async () => {
        console.log('load')
        const currentTime = await player.getCurrentTime()
        vm.$emit('video:init', vm.VIMEO_PLAYER_SETUP(currentTime))
      })
      player.on('ended', async () => {
        console.log('ended')
        const currentTime = await player.getCurrentTime()
        vm.$emit('video:ended', vm.VIMEO_PLAYER_SETUP(currentTime))
      })
    },
    VIMEO_PLAYER_SETUP(currentTime, player = null) {
      return {
        currentTime: (duration = 0) => {
          console.log(duration, 'duration', 'current time')
          if (duration && player) {
            player.setCurrentTime(duration)
          }
          return currentTime
        },
      }
    },
  },
  mounted() {
    if (this.isYoutubeVideo) {
      setTimeout(() => {
        this.YOUTUBE_SETUP()
      }, 1000)
    }
    if (this.isVimeoVideo) {
      setTimeout(() => {
        this.VIMEO_SETUP()
      }, 1000)
    }
  },
  beforeDestroy() {
    clearInterval(this.playingInterval)
  },
}
